module.exports = __webpack_public_path__ + "static/media/mz.ef4657da.svg";